import React from 'react'
import { css, SerializedStyles } from '@emotion/react'
import { colors, font } from 'plume-ui'
import { Help } from '@/components/common/Help'

type Props = {
  title: string
  sub?: React.ReactNode
  children?: React.ReactNode
  className?: string
  isSpaceBetween?: boolean
  subTitleCss?: SerializedStyles
  helpText?: string
  helpLink?: string
  'data-test-id'?: string
}

export const CardInnerTitle: React.FC<Props> = (props) => {
  return (
    <div
      css={css`
        padding: 1.5rem 1rem;
        border-bottom: 2px solid ${colors.border};
        display: flex;
        align-items: center;
        height: 64px;
        ${props.isSpaceBetween && 'justify-content: space-between;'}
      `}
      className={props.className}
    >
      <h3
        data-test-id={props['data-test-id']}
        css={css`
          margin: 0 4px 0 0;
          font-size: 16px;
          font-weight: ${font.weight.bold};
          color: ${colors.textStrong};
        `}
      >
        {props.title}
      </h3>
      {props.helpText && (
        <Help linkTo={props.helpLink || undefined} size="large">
          {props.helpText}
        </Help>
      )}
      {props.sub && (
        <div
          css={css`
            font-size: 14px;
            color: ${colors.textLight};
            font-weight: ${font.weight.normal};
            margin: 0 35px 0 16px;
            ${props.subTitleCss}
          `}
        >
          {props.sub}
        </div>
      )}
      {props.children}
    </div>
  )
}
